<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv5 flex-row flex__center">STT</div>
        <div class="theTitle theTitle__lv1 flex-row flex__left padding-left-10">{{title}}</div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar class="scroll-area" :settings="perfectScrollbarSetting" infinite-wrapper>
      <div class="list-docs">
        <div
          v-for="(item, $itemIndex) in this.data"
          v-bind:key="$itemIndex"
          class="item flex-row flex__between"
        >
          <div class="leftSection flex-row flex__left clickable" @click="viewDetail(item)">
            <div class="theTitle__lv5">
              <div class="flex-row flex__left">
                <div class="section-check">
                  <span class="stt flex-row flex__center">{{$itemIndex + 1}}</span>
                </div>
                <img class="icon-small" src="../../../assets/img/symbol/doc.svg" alt>
              </div>
            </div>
            <div class="theTitle__lv1 margin-right-10">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable">{{item.deptName + " - Cấp " + item.level}}</div>
                <div class="tt_2 flex-row flex__left margin-top-10">
                  <span>{{item.flowCode}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "dangxulyMainContent",
  props: ["data", "title"],
  components: {
    VuePerfectScrollbar
  },
  filters: { dateFormatter },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetail", {
        item: item
      });
    },
    infiniteHandler($state) {
      this.$emit("infiniteHandler", $state);
    }
  },
  data() {
    return {
      currentSortBy: "createTime",
      currentCreateTimeOrder: "desc",
      currentUpdateTimeOrder: "desc"
    };
  },
  watch: {
    data(newValue) {
      if (newValue !== this.data) {
        this.data = newValue;
      }
    }
  }
};
</script>

<style scoped>
.checkBtn {
  height: 100px;
  width: 100px;
}
.list {
  height: calc(100% - 110px) !important;
  width: 50%;
  float:left;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/tools/listDept.vue